export const ENVIRONMENT_ID = process.env.REACT_APP_ENVIRONMENT_ID || '';
export const API_URL = process.env.REACT_APP_API_URL || '';
export const API_LOCAL_URL = process.env.REACT_APP_API_LOCAL_URL || '';
export const API_LIVE_URL = process.env.REACT_APP_API_LIVE_URL || '';
export const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || '';
export const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '';
export const EMAILJS_USER_ID = process.env.REACT_APP_EMAILJS_USER_ID || '';